import { render } from "./ProductForm.vue?vue&type=template&id=972210ac&scoped=true"
import script from "./ProductForm.vue?vue&type=script&lang=js"
export * from "./ProductForm.vue?vue&type=script&lang=js"

import "./ProductForm.vue?vue&type=style&index=0&id=972210ac&scoped=true&lang=css"
import "./ProductForm.vue?vue&type=style&index=1&id=972210ac&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-972210ac"]])

export default __exports__